import React from "react";
import i18n from "i18next";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import { setUrlParameter } from "@/utils";
import LPMain from "@/react-components/LPMain";
import NewsReleaseListItem from "@/react-components/NewsReleaseListItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";
import BackButton from "@/react-components/BackButton";

class LPNewsSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageParams: {
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 10,
        totalPage: 1,
      },
      newsReleaseList: undefined,
    };
  }

  componentDidMount() {
    this.fetchNewsReleaseData();
  }

  fetchNewsReleaseData = () => {
    const { pageParams } = this.state;
    const state = getWindow()?.history?.state || {};
    state.params = pageParams;
    getWindow().history.replaceState(state, "");
    api.lp
      .getNewsReleaseList({
        pageIndex: pageParams.pageNo,
        pageSize: pageParams.pageSize,
      })
      .then((response) => {
        pageParams.totalPage = parseInt(
          (response.totalCount + pageParams.pageSize - 1) / pageParams.pageSize
        );
        this.setState({
          pageParams,
          newsReleaseList: response.list,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            page: pageParams.pageNo,
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    const { pageParams } = this.state;
    pageParams.pageNo = page;
    this.setState({ pageParams }, () => {
      this.fetchNewsReleaseData();
    });
  };

  render() {
    const {
      newsReleaseList,
      pageParams: { totalPage, pageNo },
    } = this.state;

    return (
      <LPMain className="lp-news-container">
        <div className="lp-news-container-title">
          {i18n.t("TCLs0029_lp_news_notifiction_title")}
        </div>
        <div className="lp-news-container-content">
          <BackButton title={i18n.t("common_back_home_button_title")} />
          {newsReleaseList && (
            <React.Fragment>
              <div className="lp-news-container-content-list">
                {newsReleaseList.map((item, index) => (
                  <NewsReleaseListItem key={index} data={item} />
                ))}
              </div>
              {/* 改ページ */}
              {newsReleaseList.length > 0 ? (
                <div className="pagination-container">
                  <Pagination
                    totalPage={totalPage}
                    pageIndex={pageNo}
                    onChange={this.pageChange}
                  />
                </div>
              ) : (
                <EmptyResult />
              )}
            </React.Fragment>
          )}
        </div>
      </LPMain>
    );
  }
}

export default LPNewsSection;
